<template>
  <div style="height: 100%; background-color: #fff; font-size:13px">
    <div class="title">
      <strong @click="goIndex" style="cursor: pointer"
        ><i class="el-icon-back"></i
      ></strong>
      <span>创建提成方案</span>
    </div>

    <!-- 基本信息-->
    <el-row>
      <el-col
        ><div class="base-info">
          <span class="line"></span> <span>基本信息</span>
        </div></el-col
      >
    </el-row>

    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="140px"
      class="demo-ruleForm"
    >
      <el-form-item label="提成方案类型：" required :key="0">
        <el-select v-model="form.planTypeDetail" placeholder="请选择提成方案">
          <el-option
            label="营业额（含店内销售、外卖销售）"
            value="mdyyetc"
          ></el-option>
          <el-option
            label="营业收入（含店内销售、外卖销售）"
            value="mdyysrtc"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="方案名称：" required prop="planName" :key="1">
        <el-input placeholder="请选择方案名称" v-model="form.planName"></el-input>
      </el-form-item>
      <el-form-item label="提成类型：" :key="2">
        <el-col class="text-simple">消费提成</el-col>
      </el-form-item>
      <el-form-item label="适用门店：" :key="3">
        <el-col class="text-simple">{{form.merchantName}}</el-col>
      </el-form-item>
      <el-form-item label="提成核算周期：" :key="4">
        <el-radio v-model="form.checkPeriodType" label="my">每月</el-radio>
        <!-- <el-radio v-model="form.checkPeriodType" label="mz">每周</el-radio> -->
        <el-radio v-model="form.checkPeriodType" label="mr">每日</el-radio>
      </el-form-item>
      <el-form-item label="方案有效期" :key="5">
        <el-radio v-model="form.effectiveType" label="1">永久有效</el-radio>
        <el-radio v-model="form.effectiveType" label="0">自定义时间</el-radio>
      </el-form-item>
      <!-- 每月 -->
      <el-form-item
        :key="6"
        v-if="form.effectiveType == 0 && form.checkPeriodType == 'my'"
        label="自定义日期月："
      >
        <el-date-picker
        value-format="yyyy-MM"
          v-model="dateRange"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <!-- 每周 -->
      <!-- <el-form-item
        :key="7"
        v-if="form.effectiveType == 0 && form.checkPeriodType == 'mz'"
        label="自定义日期周："
      >
        <el-date-picker
          v-model="dateRange"
          type="weekrange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item> -->
      <!-- 每日 -->
      <el-form-item
        :key="8"
        v-if="form.effectiveType == 0 && form.checkPeriodType == 'mr'"
        label="自定义日期日："
      >
        <el-date-picker
        value-format="yyyy-MM-dd"
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <!-- 提成信息 -->
    <el-row>
      <el-col
        ><div class="base-info">
          <span class="line"></span> <span>提成信息</span>
        </div></el-col
      >
    </el-row>
    <el-form :model="ruleForm" label-width="140px" class="demo-ruleForm">
      <el-form-item label="提成计算方式：">
        <el-select  @change="changeType" v-model="form.calculateType" placeholder="请选择提成方案">
          <el-option label="按阶梯计算" value="ajtjs"></el-option>
          <el-option label="按固定金额或比例" value="agdjehbl"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="详细计算规则："
        required
        v-if="form.calculateType == 'ajtjs'"
      >
        <el-radio v-model="form.calculateDetailType" label="aljyyejs"
          >按累计营业额计算</el-radio
        >
        <el-radio v-model="form.calculateDetailType" label="aljyyeccdbfjs"
          >按累计营业额超出的部分计算</el-radio
        >
      </el-form-item>

      <el-form-item label=" " v-if="form.calculateType == 'agdjehbl'">
        <el-radio v-model="form.calculateDetailType" label="cebfgdje"
          >超额部分固定金额</el-radio
        >
        <el-radio v-model="form.calculateDetailType" label="qbyyeabl"
          >全部营业额按比例</el-radio
        >
        <el-radio v-model="form.calculateDetailType" label="cebfabl"
          >超额部分按比例</el-radio
        >
        <el-radio v-model="form.calculateDetailType" label="dcmbhmrgdje"
          >达成目标后，每人固定金额</el-radio
        >
      </el-form-item>

      <el-form-item
        label="设定营业额："
        required
        v-if="
          form.calculateType == 'ajtjs' &&
          form.calculateDetailType == 'aljyyeccdbfjs'
        "
      >
        <el-input placeholder="" v-model="form.criticalAmount">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <div class="table-div" v-if="form.calculateType == 'ajtjs'">
        <div class="item" v-for="(item, i) in stepList">
          <div class="index">阶梯{{ i + 1 }}：</div>
          <div class="body">
            <div
              class=""
              v-html="
                `￥${
                  i == 0 ? '0' : stepList[i - 1].maxCriticalAmount
                } <&nbsp;营业额&nbsp;≤`
              "
            ></div>
            <div class="input-group first-step">
              <el-input
                placeholder="请输入内容"
                maxlength="8"
                v-model="item.maxCriticalAmount"
                v-if="i + 1 != stepList.length"
              >
                <template slot="append">元</template>
              </el-input>
              <el-input placeholder="无限" v-else disabled class="last-input">
              </el-input>
            </div>
            <span style="margin-left: 6px; margin-right: 6px">,</span>
            <span style="margin-right: 6px"> 总提成金额 </span>
            <el-select
              v-model="item.commissionType"
              placeholder="按百分比"
              class="by-percent"
              :disabled="i != 0"
              @change="changeCommissionType(item.commissionType)"
            >
              <el-option value="2" label="按百分比"></el-option>
              <el-option value="1" label="按固定金额"></el-option>
            </el-select>
            <div class="input-group" v-if="item.commissionType == '2'">
              <input type="text" v-model="item.royaltyRate" />
              <div class="span">%</div>
            </div>
            <div class="input-group" v-if="item.commissionType == '1'">
              <input type="text" v-model="item.royaltyAmount" />
              <div class="span">元</div>
            </div>
            <div
              class="right-delete"
              v-if="i != 0 && i != 1"
              @click="deleteOneRow(i)"
            >
              <span>删除</span>
            </div>
          </div>
        </div>
        <div class="add" @click="addStep">添加一条阶梯规则</div>
      </div>

      <el-row type="flex" class="input-div" v-if="form.calculateType == 'agdjehbl'">
        <el-col :span="12" v-if="form.calculateDetailType == 'cebfgdje'">
          <el-form-item label="累计营业额 ≥">
            <el-input style="width:70%" placeholder="" v-model="form.criticalAmount"> <template slot="append">元</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.calculateDetailType == 'cebfgdje'">
          <el-form-item label="总提成金额：">
            <el-input style="width:70%" placeholder="" v-model="form.royaltyAmount"> <template slot="append">元</template></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24" v-if="form.calculateDetailType == 'qbyyeabl'">
          <el-form-item label="提成金额 = 总营业额 ×" label-width="300px">
            <el-input style="width:70%" placeholder="" v-model="form.royaltyRate"> <template slot="append">%</template></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12" v-if="form.calculateDetailType == 'cebfabl'">
          <el-form-item label="累计营业额＞">
            <el-input style="width:70%" placeholder="" v-model="form.criticalAmount"> <template slot="append">元</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.calculateDetailType == 'cebfabl'">
          <el-form-item label="时，总提成为超出部分的" label-width="250px">
            <el-input style="width:70%" placeholder="" v-model="form.royaltyRate"> <template slot="append">%</template></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12" v-if="form.calculateDetailType == 'dcmbhmrgdje'">
          <el-form-item label="累计营业额 ≥">
            <el-input style="width:70%" placeholder="" v-model="form.criticalAmount"> <template slot="append">元</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.calculateDetailType == 'dcmbhmrgdje'">
          <el-form-item label="每人提成金额：">
            <el-input style="width:70%" placeholder="" v-model="form.royaltyAmount"> <template slot="append">元</template></el-input>
          </el-form-item>
        </el-col>

      </el-row>

      <el-form-item>
        <div style="height: 2px; background: gray"></div>
      </el-form-item>
      <!--  -->
      <el-form-item label="提成分配">
        <!-- <el-radio v-model="form.allocationType" label="1">按岗位分配</el-radio> -->
        <el-radio v-model="form.allocationType" label="1"
          >按指定员工分配</el-radio
        >
      </el-form-item>
      <el-form-item label="提成分配比例">
        <el-row>
          <el-col><span style="font-size: 13px; color: #f59a23" @click="addType">添加员工</span></el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <el-form :data="form.allocateList" ref="form.allocateList">
      <el-table ref="form.allocateList" :data="form.allocateList" height="246" style="width: 70%">
        <el-table-column type="index" label="序号" :key="0"></el-table-column>
        <el-table-column :key="1" prop="userCode" label="账号"></el-table-column>
        <el-table-column :key="2" prop="userName" label="昵称"></el-table-column>
        <el-table-column :key="3" label="提成比例">
          <template slot-scope="scope">
            <el-input class="table-input" v-model="scope.row.allocateRate">
              <template slot="append">%</template>
            </el-input>
          </template>
        </el-table-column>

        <el-table-column label="操作" :key="4" width="100">
          <template slot-scope="scope">
            <el-popconfirm @confirm="deleteTableRow(scope.$index)" @onConfirm="deleteTableRow(scope.$index)" title="确定删除该员工吗？">
              <span slot="reference" style="color:#f60000;cursor: pointer;">删除</span>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-form>

    <div
      class="line"
      style="
        height: 1px;
        background-color: #e8e8e8;
        width: 100%;
        margin-bottom: 8px;
      "
    ></div>
    <div class="foot">
      <el-button @click="$router.push('/commission')">取消</el-button>
      <el-button type="primary" @click="submitForm('form')"
        >保存并创建</el-button
      >
    </div>


    <el-dialog title="选择员工" :visible.sync="dialogVisible" width="60%">
      <div class="dialog-body">
    <div class="right">
      <el-table
      v-loading="loadingDialog"
       @selection-change="handleSelectionChange"
      :data="allocateList"
       height="290"
      style="width: 100%">
      <el-table-column type="selection" fixed></el-table-column>
      <el-table-column
        prop="loginName"
        label="登录名"
        align="center"
        >
      </el-table-column>
      <el-table-column
        prop="phone"
        align="center"
        label="手机号"
        >
      </el-table-column>
      <el-table-column
        prop="userType"
        align="center"
        label="用户类型"
        >
      </el-table-column>
      <el-table-column
        prop="status"
        align="center"
        label="状态"
        >
      </el-table-column>
      
    </el-table>
    </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="showTable">确 定</el-button>
  </span>
</el-dialog>
    <!-- <el-dialog
  title="选择菜品"
  :visible.sync="dialogVisible"
  width="30%"
  >
  <input type="text" style="width: 100%;height: 26px;outline:none" placeholder="请输入菜品名" v-model="dishType">
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
</el-dialog> -->


  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        merchantCode: "",
        merchantName: "",
        planType: "mdyytc", //单前页门店营业提成
        commissionType: "xftc",
        planTypeDetail: "mdyyetc", //提成方案类型
        planName: "", //方案名称
        effectiveType: "1", //方案有效期
        checkPeriodType: "my", //提成核算周期
        startDate: "",
        endDate: "",
        calculateType: "ajtjs", //提成计算方式
        // dishType:'2',//指定菜品
        allocationType: "1", //岗位
        calculateDetailType: "aljyyejs", //详细计算规则
        productList: [],
        allocateList:[],//指定员工列表
        freeDishFlag: true, //赠菜
      },
      merchantCode: "",
      allocateList:[],//选择员工列表

      stepList: [
        { maxCriticalAmount: "", commissionType: "2", royaltyRate: "" },
        { maxCriticalAmount: "", commissionType: "2", royaltyRate: "" },
      ], //阶梯
      commissionPeriod: "1", //提成核算周期
      dishType: "",
      dialogVisible: false,
      loadingDialog:true,
      input: "",
      tableData: [],
      selected:[],
      checked: "",
      dateRange: [],
      radio: "",
      radio2: "",
      radio3: "",
      //
      ruleForm: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
      },
    };
  },

  created () {
      this.merchantCode=localStorage.getItem('merchantCode')
      this.form.merchantCode=localStorage.getItem('merchantCode')
      this.form.merchantName=localStorage.getItem('merchantName')
      //  this.debouncedSearch = _debounce(this.search, 500);
      if(this.$route.query.type && this.$route.query.code){
        this.editData()
      }
    },

  methods: {
    //添加一条阶梯规则
    addStep() {
      if (this.stepList[this.stepList.length - 2].maxCriticalAmount == "") {
        this.$message({
          message: "请先输入金额",
          type: "warning",
        });
        return;
      }
      const commissionType = this.stepList[0].commissionType
      this.stepList.push({ maxCriticalAmount: "", commissionType: commissionType, royaltyRate: "" });
    },
    //删除一条阶梯规则
    deleteOneRow(i) {
      this.stepList.splice(i, 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
          if (valid) {
          // 需要传中文名称
          if (this.form.planTypeDetail == "mdyyetc") {
            this.form.planDetailName = "营业额（含店内销售、外卖销售）";
          } else {
            this.form.planDetailName = "营业收入（含店内销售、外卖销售）";
          }
          
          // 计算提成方式
          if (this.form.calculateType == "ajtjs") {
            this.form.calculateTypeName = "按阶梯计算";
            this.form.rateList = this.stepList
          }else{
            this.form.calculateTypeName = "按固定金额或比例";
          }
          // 有效时间
          if (this.form.effectiveType == "0") {
            this.form.startDate = this.dateRange[0];
            this.form.endDate = this.dateRange[1];
          }

          console.log(this.form);
          this.$http
            .post("/merchantEmployeeRoyaltyPlan/add", this.form)
            .then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
                this.$router.push("/commission?index=2");
              } else {
                this.$message.error(res.data.message);
              }
            });
        } else {
          this.$message.error("信息填写不正确");
          return false;
        }
        });
    },

  changeType(val){
    console.log(val, 111)
    if(val == 'ajtjs'){
      this.form.calculateDetailType = 'aljyyejs'
    }
    if(val == 'agdjehbl'){
      this.form.calculateDetailType = 'cebfgdje'
    }
  },

  changeCommissionType(val){
    this.stepList.forEach(item => {
          item.commissionType = val;
        });
  },


    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    goIndex() {
      this.$confirm("确定退出编辑吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push("/commission");
        })
        .catch(() => {
          console.log("");
        });
    },

    // 添加员工 查看列表
      addType(){
        this.dialogVisible=true
        this.$http.post('/merchantUsers/queryList',{merchantCode:this.merchantCode}).then(res=>{
          this.allocateList=res.data.data
          this.loadingDialog=false
        })
      },
      handleSelectionChange(val){
        this.selected=val
      },
      showTable(){
        var arr=[]
        this.selected.forEach(item=>{
          var data={}
          data.allocationType='2'
          data.userCode=item.loginName
          data.userName=item.nickName
          arr.push(data)
        })
        this.form.allocateList=arr
        this.dialogVisible=false
      },
      deleteTableRow(i){
        this.form.allocateList.splice(i,1)
      },

      // 数据回显
      editData(){
        this.$http.post('/merchantEmployeeRoyaltyPlan/queryOne',{planType:this.$route.query.type,planCode:this.$route.query.code}).then(res=>{
          console.log(res,'数据回显')
          this.form=res.data.data
          // 方案有效期
          if(res.data.data.effectiveType==0){
            this.dateRange[0]=res.data.data.startDate
            this.dateRange[1]=res.data.data.endDate
          }
          if(this.form.calculateType == 'ajtjs'){
            this.stepList = res.data.data.rateList.map(item => ({ 
            maxCriticalAmount: item.maxCriticalAmount,
            commissionType: item.commissionType,
            royaltyRate: item.royaltyRate
          }));
          }
        })
      },
  },
};
</script>

<style  lang="less" scoped>
.table-div {
  color: #333;
  width: 1050px;
  background: #f8f8f8;
  padding: 24px 50px;
  box-sizing: border-box;
  border-radius: 2px;
  .add {
    font-size: 14px;
    color: #f59a23;
    cursor: pointer;
  }
  .item {
    display: flex;
    font-size: 14px;
    margin-bottom: 10px;
    .index {
      display: flex;
      justify-content: right;
      width: 100px;
      font-size: 14px;
      line-height: 32px;
    }
    .body {
      display: flex;
      width: 800px;
      position: relative;
      justify-content: right;
      line-height: 32px;
      .input-group {
        display: flex;
        border: 1px solid #e5e5e5;
        align-items: center;
        margin-left: 10px;
        background: #fff;
        border-radius: 4px;
        height: 28px;
        input {
          outline: none;
          border: none;
          width: 78px;
          background: #fff;
          padding: 4px 11px;
        }
        .span {
          padding-left: 10px;
          height: 100%;
          padding-left: 10px;
          padding-right: 10px;
          line-height: 32px;
          border: 1px solid #ddd;
          border-right: 0;
          background: #f8f8f8;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      }
    }
  }
}
.input-div {
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: flex-start; /* 水平开始排列 */
  color: #333;
  width: 800px;
  background: #f8f8f8;
  padding: 20px 10px;
  margin-left: 140px;
  box-sizing: border-box;
  border-radius: 2px;
}

.title {
  padding: 6px 10px;
  height: 36px;
  border-bottom: 2px solid #f6f6f6;
  display: flex;
  align-items: center;
  span {
    margin-left: 10px;
  }
  i,
  span {
    font-size: 20px;
    font-weight: 500;
  }
}
.line {
  display: inline-block;
  width: 3px;
  height: 15px;
  background-color: orange;
  margin-right: 5px;
  border-radius: 2px;
  margin-bottom: -2px;
}
.base-info {
  margin: 30px 0px 10px 20px;
}
.foot {
  display: flex;
  justify-content: right;
  height: 100px;
  background-color: #fff;
  padding-right: 60px;
}
/deep/ .el-form {
  margin: 10px 0 10px 40px;
}
/deep/ .el-form-item__content {
  margin-left: 5px !important;
}
// /deep/ .el-input__inner {
//   width: 250px;
// }
/deep/ .el-form-item {
  display: flex;
}
/deep/ .text-simple {
  color: #606266;
}
/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #f59a23;
  background-color: #f59a23;
}
/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #606266;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #f59a23;
  background-color: #f59a23;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}
//
/deep/ .by-percent {
  width: 160px;
  .el-input__inner {
    width: 160px;
  }
}
/deep/ .all-disable {
  .el-input__inner {
    width: 154px;
  }
}
/deep/.first-step {
  .el-input__inner {
    width: 100px;
  }
}
/deep/ .right-delete {
  color: #ff6000;
  font-size: 14px;
  cursor: pointer;
  position: absolute;
  right: -60px;
}
/deep/ .last-input {
  .el-input__inner {
    width: 154px;
  }
}
</style>